//预加载图片资源
export default [
    require("@/assets/img/hot-game-push/UI_RMYX_BG_01.png"),
    require("@/assets/img/hot-game-push/UI_RMYX_biaoqian_01.png"),
    require("@/assets/img/hot-game-push/UI_RMYX_biaoqian_02.png"),
    require("@/assets/img/hot-game-push/UI_RMYX_BG_01_1.png"),
    require("@/assets/img/hot-game-push/UI_RMYX_biaoqian_01_1.png"),
    require("@/assets/img/hot-game-push/UI_RMYX_biaoqian_02_1.png")
]